(function () {
  'use strict';

  var FORM_SELECTOR = 'form[id^="rsx-email-"]';
  var MARKER_KEY = 'totoStoryEmailPendingForm';
  var STYLE_ID = 'toto-story-form-style';

  var MESSAGES = {
    en: {
      invalid: 'Please enter a valid email address.',
      consent: 'Please tick the box to agree before subscribing.',
      success: 'Thank you — please check your inbox to confirm your subscription.',
      again: 'Send again'
    },
    zht: {
      invalid: '請輸入有效的電郵地址。',
      consent: '請先勾選同意，再訂閱。',
      success: '謝謝你 —— 請到收件匣確認訂閱。',
      again: '再寄一次'
    },
    zhs: {
      invalid: '请输入有效的邮箱地址。',
      consent: '请先勾选同意，再订阅。',
      success: '谢谢你 —— 请到收件箱确认订阅。',
      again: '再发一次'
    }
  };

  function langKey() {
    var raw = (document.documentElement.getAttribute('lang') || 'en').toLowerCase();
    if (raw.indexOf('zh') !== -1) {
      if (raw.indexOf('cn') !== -1 || raw.indexOf('hans') !== -1) {
        return 'zhs';
      }
      return 'zht';
    }
    return 'en';
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }
    var css =
      '.toto-story-form__status{margin-top:1.2rem;padding:1rem 1.4rem;border-radius:.4rem;font-size:1.4rem;line-height:1.5}' +
      '.toto-story-form__status:empty{display:none}' +
      '.toto-story-form__status--success{background:rgba(74,144,226,.12);border:.1rem solid rgba(74,144,226,.45)}' +
      '.toto-story-form__status--error{background:rgba(255,92,92,.1);border:.1rem solid rgba(255,92,92,.5)}' +
      '.toto-story-form__again{display:inline-block;margin-top:.8rem;padding:0;border:0;background:none;font:inherit;color:inherit;text-decoration:underline;cursor:pointer}' +
      '.toto-story-form__status:focus{outline:none}';
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
  }

  function ensureStatus(form) {
    if (form.totoStatusEl && form.totoStatusEl.isConnected) {
      return form.totoStatusEl;
    }
    var el = document.createElement('div');
    el.className = 'toto-story-form__status';
    el.id = 'toto-story-form-status-' + (form.id || 'form');
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('tabindex', '-1');
    form.appendChild(el);
    form.totoStatusEl = el;
    return el;
  }

  function clearEmailState(form) {
    var email = form.querySelector('input[type="email"]');
    if (email) {
      email.removeAttribute('aria-invalid');
      email.removeAttribute('aria-describedby');
    }
  }

  function showError(form, text) {
    var el = ensureStatus(form);
    el.textContent = text;
    el.className = 'toto-story-form__status toto-story-form__status--error';
    var email = form.querySelector('input[type="email"]');
    if (email) {
      email.setAttribute('aria-invalid', 'true');
      email.setAttribute('aria-describedby', el.id);
    }
    el.focus();
  }

  function showSuccess(form, messages) {
    var el = ensureStatus(form);
    clearEmailState(form);
    el.textContent = '';
    el.className = 'toto-story-form__status toto-story-form__status--success';
    el.appendChild(document.createTextNode(messages.success));
    el.appendChild(document.createElement('br'));
    var again = document.createElement('button');
    again.type = 'button';
    again.className = 'toto-story-form__again';
    again.textContent = messages.again;
    again.addEventListener('click', function () {
      el.textContent = '';
      el.className = 'toto-story-form__status';
      clearEmailState(form);
      var email = form.querySelector('input[type="email"]');
      if (email) {
        email.focus();
      }
    });
    el.appendChild(again);
    el.focus();
  }

  function enhance(form, messages) {
    form.noValidate = true;
    form.addEventListener('submit', function (event) {
      var email = form.querySelector('input[type="email"]');
      var consent = form.querySelector('input[name="consent"]');
      var el = ensureStatus(form);
      el.textContent = '';
      el.className = 'toto-story-form__status';
      if (email && (email.value.trim() === '' || email.checkValidity() === false)) {
        event.preventDefault();
        showError(form, messages.invalid);
        return;
      }
      if (consent && consent.type === 'checkbox' && consent.checked === false) {
        event.preventDefault();
        showError(form, messages.consent);
        return;
      }
      try {
        window.sessionStorage.setItem(MARKER_KEY, form.id);
      } catch (e) {
        /* storage unavailable: the native submit still proceeds */
      }
    });
  }

  function restore(messages) {
    var pending = null;
    try {
      pending = window.sessionStorage.getItem(MARKER_KEY);
      window.sessionStorage.removeItem(MARKER_KEY);
    } catch (e) {
      return;
    }
    if (!pending) {
      return;
    }
    var form = document.getElementById(pending);
    if (!form) {
      return;
    }
    showSuccess(form, messages);
  }

  function init() {
    var forms = document.querySelectorAll(FORM_SELECTOR);
    if (!forms.length) {
      return;
    }
    var messages = MESSAGES[langKey()] || MESSAGES.en;
    injectStyles();
    for (var i = 0; i < forms.length; i++) {
      enhance(forms[i], messages);
    }
    restore(messages);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
